import { useEffect } from "react";

import { useFormContext } from "react-hook-form";

import { parseJmbgToDate } from "utils/date";
export function usePatientForm() {
  const { watch, setValue } = useFormContext();

  const identificationNumber = watch("identificationNumber");

  useEffect(() => {
    if (!identificationNumber) return;
    const isNumeric = /^\d+$/.test(identificationNumber);
    if (!isNumeric) return;
    const date = parseJmbgToDate(identificationNumber);
    if (date) {
      setValue("birthDate", date, { shouldDirty: true, shouldTouch: true });
    }
  }, [identificationNumber, setValue]);
}
